const getCronTemplate = async ({ params, api }) => {
  return await api(`cronTemplate/${params.id}`)
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default getCronTemplate;
